export default __webpack_public_path__ + "static/media/Cookie_Generator.c5ca284d.jpg";